<template>
  <div id="header" class="grid-container full">

    <header id="main-header" >
      <div class="grid-container">
        <div class=" grid-x top-bar">
          <div class=" cell shrink">
            <nav class="text-left">
              <router-link :to="{ name: 'home' }">
                <img src="@/assets/images/logo-text.png" class="logo-center" />
              </router-link>
            </nav>
          </div>
          <div class="cell auto">
            <nav>
              <ul class="dropdown menu float-right" data-dropdown-menu>
                <li>
                  <router-link
                    :to="{ name: 'search', params: {query:'all'} }"
                    class="text-uppercase"
                  >
                    <i class="fi-magnifying-glass"></i><span class="hide-for-small-only">&nbsp;Search</span>
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'order' }" id="cart" class="text-uppercase">
                    <i class="fi-shopping-cart"></i> <strong>{{ orderInfo.count }}</strong>
                  </router-link>
                </li>
                <li v-show="isAuthenticated">
                  <router-link :to="{ name: 'userProfile' }" class="text-uppercase">
                    <i class="fi-torso"></i><span class="hide-for-small-only">&nbsp;{{ fullName }}</span>
                  </router-link>
                  <ul class="menu" >
                     <li>
                        <router-link :to="{name: 'myOrder'}" class="text-left text-uppercase">
                            My Enquiries
                        </router-link>
                    </li>
                    <li>
                      <a href="javascript:void(0);" @click="logout" class="text-left text-uppercase">Logout</a>
                    </li>
                  </ul>
                </li>
                <li v-show="!isAuthenticated">
                  <router-link :to="{ name: 'login' }" class="text-uppercase">
                    <i class="fi-torso"></i><span class="hide-for-small-only">&nbsp;My Account</span>
                  </router-link>
                </li>
                <li class="hide-for-small-only">
                  <router-link :to="{ name: 'contact' }" class="text-uppercase">
                    <i class="fi-telephone"></i><span >&nbsp;Contact</span>
                  </router-link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>

  </div>
</template>

<script>
import { EventBus } from '../event-bus'

import userInfoService from "@/app.user/services/main-service.js";
import accountService from "@/app.account/services/main-service.js";
import shoppingCartDataService from "@/store.order/services/shopping-cart-service.js";

export default {
  name: "header-view",
  mixins: [require("@/app/mixins/foundation")],
  data() {
    return {
      orderInfo: {},
      userInfo: {},
      currentCatalogId: null,
    };
  },
  mounted() {
    EventBus.$on('refreshUserInfo', this.refreshUserInfo);
  },
  created() {
    this.userInfo = userInfoService.getCurrentUserInfo();

    this.getOrderInfo();
  },
  computed: {
    fullName() {
      return this.userInfo.lastName
        ? this.userInfo.lastName + " " + this.userInfo.firstName
        : null;
    },
    isAuthenticated(){
        //TODO-VICTOR: CHECK For token or key?
        return this.fullName !== null;
    }
  },
  methods: {
    logout() {
      //Userinfo clear
      accountService.loginOut();
      this.userInfo = {};
      userInfoService.clear();

      //Shopping cart clear
      shoppingCartDataService.clear();

      //refreshUserInfo and cart
      EventBus.$emit("refreshUserInfo");

      //Redirect to home page
      this.$router.push({name:'home'});
    },
    async getOrderInfo(){
      const userInfo = await shoppingCartDataService.getInfo();
      this.orderInfo = userInfo;
    },

    refreshUserInfo(){
        this.userInfo = userInfoService.getCurrentUserInfo();

        //Return shopping cart items after logging
        this.getOrderInfo();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./../../assets/sass/settings/settings";

#header {
  //overflow: hidden;

  //background: $light-gray;
  background: #fff;

  .top-bar,
  .top-bar ul,
  li {
    background: #fff;
  }

  #main-header {
    text-align: center;
    background: rgba(255, 255, 255, 0.75);
    border-top: 1px solid #f5f5f5;
    border-bottom: 1px solid #f5f5f5;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-bottom-color: rgb(245, 245, 245);
    z-index: 9;
    position: relative;

    a {
      color: $third-color;
    }
  }
}

.sub-header {
  justify-content: center;
  align-items: center;

  border-bottom: 1px solid #efefef;

  .top-bar {
    justify-content: center;
    align-items: center;
  }
}

.top-bar-center {
  .topbar-center-logo .top-bar-center {
    flex: 1 0 auto;

    @include breakpoint(small only) {
      display: none;
    }
  }
}

a i {
  padding-right: 0.25rem;
}

.main-menu {
  margin: 0 1rem;
}

.main-menu li {
  text-transform: inherit;
  position: relative;
}

.main-menu {
  a {
    position: relative;
    color: #333;
  }
  a::after {
    content: "";

    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 85%;
    height: 1px;
    background: #666565;

    -moz-transform: scale(0, 0.5);
    -ms-transform: scale(0, 0.5);
    -o-transform: scale(0, 0.5);
    -webkit-transform: scale(0, 0.5);
    transform: scale(0, 0.5);

    -moz-transform-origin: 0;
    -ms-transform-origin: 0;
    -o-transform-origin: 0;
    -webkit-transform-origin: 0;
    transform-origin: 0;

    -moz-transition: all 0.35s ease;
    -o-transition: all 0.35s ease;
    -webkit-transition: all 0.35s ease;
    transition: all 0.35s ease;

    margin: 0 auto;
  }
  a:hover {
    text-decoration: none;
    color: rgb(57, 133, 209);
    &::after {
      background: rgb(57, 133, 209);
    }
  }
  a:hover::after {
    transform: scale(1, 0.5);
  }
}

.logo-center {
  height: 30px;
}

.router-link-exact-active {
  text-decoration: none;
  color: rgb(57, 133, 209) !important;
  &::after {
    background: rgb(57, 133, 209) !important;
    // transform: scale(1, 0.5) !important;
  }
}
</style>

<style lang="scss" scoped>
/* The magic */
// .col {
//   // Prepare for absolute slide
//   overflow: hidden;
//   position: relative;
// }

.slide {
  // Position inside column
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0;
  
  /* 
    Visibility delay gives the previously hovered element time to slide out before disappearing.
    Remove the `visibility` transition to slide in current element without sliding out previous element
  */
  $speed: 0.275s;
  transition: all $speed ease-in-out, visibility 0s $speed;
  visibility: hidden;
  will-change: transform;
  // Slides start below their columns, giving upward motion on hover
  transform: translateY(100%);
}

.row:hover {
  // Next row, slides are above their columns, giving downward motion on hover
  & ~ .row .slide { transform: translateY(-100%); }
  
  // Current row, slides to the right of their columns, giving left motion on hover
  .slide { transform: translateX(100%); }
  
  // Current row, next slides, slides to the left of their columns, giving right motion on hover
  & .col:hover ~ .col .slide { transform: translateX(-100%); }
  
  // Current slide
  .col:hover .slide {
    transform: none;
    visibility: visible;
    transition-delay: 0s;
  }
}

/* Pen styling */
// This a mess, ignore




// .row { 
//   display: flex;
// }

// .col {
//   color: #fff;
//   flex: 1 1 auto;
//   min-height: 260px;
//   position: relative;
  
// }

// Some size difference for variety
// .col:nth-child(2) { min-width: 20%; }
// .col:nth-child(4) { min-width: 33%; }
// .col:nth-child(3) + .col:nth-child(3) { min-width: 50%; }

// Photo is in its own container, so we can zoom it
.photo-container {
  background: #0f0523 50% 50% / cover;
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0;
  
-moz-transition: 1s;
    -o-transition: 1s;
    -webkit-transition: 1s;
    transition: 1s;

  -moz-transform-origin: bottom right;
    -ms-transform-origin: bottom right;
    -o-transform-origin: bottom right;
    -webkit-transform-origin: bottom right;
    transform-origin: bottom right;
  
  &::before {
    background: linear-gradient(transparent, rgba(#431133, 0.5), #000320);
    content: '';
    position: absolute;
    top: 0; right: 0; bottom: 0; left: 0;
  }
  
  // .col:hover & {
  //   transform: scale(1.25);
  // }
}

// Basic slide styles
.slide {
  background: rgba(#190115, 0.8);
  padding: 0 1.5rem;
}

</style>